import { FilterTypesEnum } from '../enums/filters-types.enum';
import { FilterOptionModel } from './filter-option.model';
import { ChipModel } from '../../Forms/models/chip.model';
import { FilterTypeCheckboxModel } from './filter-type-checkbox.model';
import { Type } from '@angular/core';
import { AbstractFilterTypeComponent } from './abstract-filter-type.component';
import { CustomFilterTypeModel } from './custom-filter-type.model';
import { FilterQuickOptionModel } from './filter-quick-option.model';
import {clone} from 'underscore';


export enum TaggingEnum {
    auto,
    onDemand
};
export const ALL_AUTO_TAGGING_TOPICS_CHIPS: ChipModel = {
    id: TaggingEnum.auto,
    label: 'Monitoring.filter.tagging.allAutoTaggingTopics'
};
export const ALL_ON_DEMAND_TAGGING_TOPICS_CHIPS: ChipModel = {
    id: TaggingEnum.onDemand,
    label: 'Monitoring.filter.tagging.allOnDemandTopics'
};
export class FilterTypeAutoTaggingTopicsCheckboxModel extends FilterTypeCheckboxModel<number> implements CustomFilterTypeModel<number[]> {
    readonly key: FilterTypesEnum = FilterTypesEnum.custom;

    declare value: number[];
    declare currentValue: number[];

    customComponent: Type<AbstractFilterTypeComponent>;
    autoTagOptions: TaggingEnum[] = [];
    taggingEnumToChipMap = new Map([
        [TaggingEnum.auto, ALL_AUTO_TAGGING_TOPICS_CHIPS],
        [TaggingEnum.onDemand, ALL_ON_DEMAND_TAGGING_TOPICS_CHIPS],
    ]);

    constructor(
        id: string,
        label: string,
        component: Type<AbstractFilterTypeComponent>,
        options?: FilterOptionModel<number>[],
        value?: number[],
        showIncludeExclude?: boolean
    ) {
        super(
            id,
            label,
            options,
            true,
            null,
            value,
            undefined,
            undefined,
            undefined,
            showIncludeExclude
        );
        this.customComponent = component;
    }

    /**
     * Sets the active value for this filter
     * @param value
     */
    setValue(value: number[]): void {
        this.value = value;
        if (this.options) {
            this.chips = this.value.map(tagId => {
                const chip: ChipModel = clone(this.options.find((option) => option.value === tagId));
                return chip;
            }).filter(chip => !!chip);
        }
        if (this.autoTagOptions) {
            this.autoTagOptions.forEach(option => {
                const chip = clone(this.taggingEnumToChipMap.get(option));
                this.chips.push(chip);
            });
        }
        this.cancelChanges();
        this.updateChipSuffix();
    }

    /**
     * Gets the active value for this filter
     */
    getValue(): number[] {
        return this.value;
    }

    /**
     * Handles deleting a chip for the active value of this filter
     * @param chip A chip from this filter
     */
    removeChip(chip: ChipModel): void {
        if (chip.id === ALL_AUTO_TAGGING_TOPICS_CHIPS.id) {
            this.autoTagOptions.splice(this.autoTagOptions.findIndex(x => x === TaggingEnum.auto), 1);
        }
        if (chip.id === ALL_ON_DEMAND_TAGGING_TOPICS_CHIPS.id) {
            this.autoTagOptions.splice(this.autoTagOptions.findIndex(x => x === TaggingEnum.onDemand), 1);
        }
        this.value = this.value
            .filter(tagId => tagId !== (<any>chip).value);

        this.setValue(this.value);
    }

    /**
     * Resets the filter to not apply any changes
     */
    clear(): void {
        this.autoTagOptions = [];
        this.setValue([]);
    }

    /**
     * Sets the current value for a filter
     * @param value
     */
    setCurrentValue(value: number[]): void {
        this.currentValue = value;
        if (this.options) {
            this.currentChips = this.currentValue.map(tagId => {
                const chip: ChipModel = this.options.find((option) => option.value === tagId);
                return chip;
            }).filter(chip => !!chip);
        }
        if (this.autoTagOptions) {
            this.autoTagOptions.forEach(option => {
                const chip = this.taggingEnumToChipMap.get(option);
                this.currentChips.push(chip);
            });
        }

        this.updateCurrentChipSuffix();
    }

    /**
     * Gets the current value for a filter
     */
    getCurrentValue(): number[] {
        return this.currentValue;
    }

    /**
     * Handles deleting a chip for the current value of this filter
     * @param chip A chip from this filter
     */
    removeCurrentChip(chip: ChipModel): void {
        if (chip.id === ALL_AUTO_TAGGING_TOPICS_CHIPS.id) {
            this.autoTagOptions.splice(this.autoTagOptions.findIndex(x => x === TaggingEnum.auto), 1);
        }
        if (chip.id === ALL_ON_DEMAND_TAGGING_TOPICS_CHIPS.id) {
            this.autoTagOptions.splice(this.autoTagOptions.findIndex(x => x === TaggingEnum.onDemand), 1);
        }

        this.currentValue = this.currentValue
            .filter(tagId => tagId !== (<any>chip).value);

        this.setCurrentValue(this.currentValue);
    }

    quickAutocomplete(query: string, translateMethod: (str: string) => string): FilterQuickOptionModel<number>[] {
        const queryLower = query.toLocaleLowerCase();
        const matchedOptions = this.options.filter(
            opt => {
                if (this.value.includes(opt.value)) {
                    return false;
                }
                return opt.label.toLocaleLowerCase().includes(queryLower);
            }
        );

        return matchedOptions.map(opt => {
            return {
                label: opt.label,
                value: opt.value,
                count: opt.count,
                filter: this
            };
        });
    }
    addQuickOption(option: FilterQuickOptionModel<number>): void {
        this.setValue([...this.value, option.value]);
    }
}
